import { Check, TriangleAlert } from 'lucide-react';

interface Props {
  message: string;
  failed: boolean;
}

export function Toast({ message, failed }: Props) {
  return (
    <div className="toast" role="status" aria-live="polite">
      {failed ? <TriangleAlert size={15} /> : <Check size={15} />}
      {message}
    </div>
  );
}
